import { Modal, Switch, Text } from '@/components';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useDevToolsStorage } from '../_hooks/local-storage';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export const TargetEnvBannerModal: FC<Props> = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const { devtoolState, setDevtoolState } = useDevToolsStorage();

  const handleChange = (checked: boolean) => {
    setDevtoolState({ isTargetEnvBannerHidden: !checked });
  };

  return (
    <Modal
      title={t('dev-tools.target-env-banner-label')}
      open={isOpen}
      onCancel={onClose}
      footer={null}
      width={600}
    >
      <Text text={t('dev-tools.target-env-banner-description')} />
      <Switch
        checked={!devtoolState?.isTargetEnvBannerHidden}
        onChange={handleChange}
        checkedLabel={t('switch-on')}
        unCheckedLabel={t('switch-off')}
      />
    </Modal>
  );
};
